// extracted by mini-css-extract-plugin
module.exports = {"shippingLocation":"shipping-location-module__shippingLocation___2RkLy"};